import React, { useEffect, useRef, useState } from "react";
import { Box, Container, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setCouponCookie } from "../../utils/affiliateCoupon";
import ButtonComponent from "../../Components/ButtonComponent";
import { useAppSelector } from "../../store";
import { getFullState } from "../../store/slices/auth/auth.slice";
import { useLazyValidateCouponQuery } from "../../store/services/affiliate/affiliate.service";
import { notifyError } from "../../utils/NotifyError";
import { IError } from "../../utils/getErrorMessage";
import { AffiliateCreateCouponDTO } from "../../store/services/affiliate/dto/affiliate.dto";
import { getDiscountAmount } from "../../utils/getInvitationPrice";

const ActivateAffiliate = () => {
	const [searchParams] = useSearchParams();
	const coupon = searchParams.get("coupon");
	const navigate = useNavigate();
	const { user } = useAppSelector(getFullState);
	const initialized = useRef(false);
	const [isLoading, setIsLoading] = useState(true);
	const [couponObject, setCouponObject] = useState<AffiliateCreateCouponDTO | null>(null);
	const [couponStatus, setCouponStatus] = useState<"valid" | "invalid" | null>(null);
	const [ValidateCoupon] = useLazyValidateCouponQuery();

	useEffect(() => {
		if (initialized.current) return;
		initialized.current = true;

		setCouponStatus(null);
		setCouponObject(null);
		ValidateCoupon({ code: coupon || "" }).then(({ data, error }) => {
			if (data) {
				if (data.valid && user) {
					setCouponCookie(user._id, data.coupon.code);
					setCouponObject(data.coupon);
					setIsLoading(false);
					setCouponStatus("valid");
				} else if (!data.valid) {
					setIsLoading(false);
					setCouponStatus("invalid");
				}
			}
			if (error) {
				notifyError(error as IError);
				setIsLoading(false);
				setCouponStatus(null);
			}
		});
	}, []);

	return (
		<Container>
			<Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} height={"90vh"}>
				{isLoading ? (
					<>
						<Typography variant={"h6"} sx={{ marginBottom: "40px", fontWeight: "bold" }}>
							Coupon is being applied
						</Typography>
						<CircularProgress size={60} />
					</>
				) : couponStatus === "valid" ? (
					<>
						<Typography
							variant={"h6"}
							sx={{ marginBottom: "12px", fontWeight: "bold", maxWidth: "450px" }}
							textAlign={"center"}
						>
							{coupon && couponObject
								? `Coupon ${coupon} was validated successfully, 
								${getDiscountAmount(couponObject.discount || 0, couponObject.currency || "EGP", couponObject.is_discount_percentage || true)} discount
								 will be applied on checkout`
								: "No coupon was provided"}
						</Typography>
						{coupon && (
							<Typography variant={"body2"} color={"textSecondary"} textAlign={"center"} sx={{ marginBottom: "24px" }}>
								It will be automatically used during checkout.
							</Typography>
						)}
						<ButtonComponent
							variant={"contained"}
							color={"primary"}
							loading={false}
							onClick={() => navigate("/invitation-templates")}
							text={"Browse Invitation Templates"}
						/>
					</>
				) : (
					<>
						<Typography variant={"h6"} sx={{ marginBottom: "12px", fontWeight: "bold" }} textAlign={"center"}>
							{"Invalid Coupon Code"}
						</Typography>
						<Typography variant={"body2"} color={"textSecondary"} textAlign={"center"} sx={{ marginBottom: "24px" }}>
							please use valid coupon code link to be automatically applied during checkout
						</Typography>
						<ButtonComponent
							variant={"contained"}
							color={"primary"}
							loading={false}
							onClick={() => navigate("/invitation-templates")}
							text={"Browse Invitation Templates"}
						/>
					</>
				)}
			</Box>
		</Container>
	);
};

export default ActivateAffiliate;
